export const formContent = {
    holderName: {
        id: 'holderName',
        label: 'Holder Name',
        type: 'text',
        validation: {
            required: "Please enter holder name"
        }
    },
    cardNumber: {
        id: 'cardNumber',
        label: 'Card Number',
        type: 'number',
        validation: {
            required: "Card number is required"
        }
    },
    expDate: {
        id: 'expDate',
        label: 'Exp. Date',
        type: 'month',
        validation: {
            required: "Exp. date is required"
        }
    },
    cvv: {
        id: 'cvv',
        label: 'CVV',
        type: 'number',
        validation: {
            required: "CVV is required"
        }
    },
    payIDnumber: {
        id: 'payIDnumber',
        label: 'Pay ID',
        type: 'number',
        validation: {
            required: "Pay ID is required"
        }
    },
    paymentButton: {
        id: 'paymentButton',
        label: 'Pay',
        type: 'submit'
    }
}
